<lib-select
  [options]="optionsArray"
  [multi]="true"
  [showSearch]="false"
  [disabled]="isReadonly"
  [placeholder]="props.placeholder ?? ''"
  [value]="selectedOptionsValues"
  [testId]="props.testId"
  [minHeight]="100"
  [maxHeight]="500"
  (valueChange)="formControl.setValue($event)"
/>
